<template>
  <div class="loginBox">
    <h1>Login</h1>
      <div v-if="errors.length" class="errorCard">
        <p v-for="error in errors" :key="error">
          {{ error }}
        </p>
      </div>
      <form @submit.prevent="submit">
        <input type="text" v-model="login" placeholder="Username" :disabled="loading"/>
        <input type="password" v-model="password" placeholder="******" :disabled="loading"/>
        <button class="btn primary" :disabled="loading">Submit</button>
      </form>
      <hr />
      <p>
        <router-link class="link" to="/forgot">Forgot password ? Reset it</router-link>
      </p>
      <p>
        <router-link class="link" to="/register">Don't have a account ? Register</router-link>
      </p>
  </div>
</template>

<script>
export default {
  data: () => ({
    login:null,
    password:null,
    loading: false,
    errors: []
  }),
  methods:{
    submit(){
      this.loading = true
      this.errors = []
      this.$store.dispatch("auth/login",{
        username:this.login,
        password:this.password
      }).then(() => {
        this.$router.push("/")
      }).catch(({data}) => {
        if(data.errors){
          console.log(data.errors)
          for (const entry of Object.entries(data.errors)) {
            this.errors.push(entry[1].join(","))
          }
        }else if(data.message){
          this.errors.push(data.message)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less">
.loginBox{
    text-align: left;
    max-width: 500px;
    width: 100%;
    background-color: #fff;
    padding: 50px;
    margin: 50px 0;
    h1{
      font-size: 24px;
      color: #2F2B2B;
      margin-bottom: 50px;
      font-weight: 800;
    }
    hr{
      border-color: transparent;
      margin-bottom: 30px;
      margin-top: 30px;
      display: block;
    }
    p{
      line-height: 1.5em;
    }
    .errorCard{
      padding: 10px;
      margin-bottom: 25px;
      border-radius: 10px;
      background-color: #ef5350;
      color:#FFEBEE;
      
    }
  }
</style>